import { useEffect, useState } from "react";
import axios from "axios";

const DefaultExtensions = (props, storeExtention) => {
  const [extensions, setExtensions] = useState([]);

  const subscription = JSON.parse(localStorage.getItem("subscription"));
  const getExtensions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_EP_URL}/api/extensions${props.user.slug}`,
        {
          headers: {
            Authorization: "Bearer " + props.user.accessToken,
          },
        }
      );

      const backgroundColors = [
        "#93C5FD", // Medium-Light Blue
        "#C4B5FD", // Medium-Light Purple
        "#6EE7B7", // Medium-Light Green
        "#FCD34D", // Medium-Light Orange
        "#F87171", // Medium-Light Red
        "#67E8F9", // Medium-Light Cyan
        "#A5B4FC", // Medium-Light Indigo
        "#FDBA74", // Medium-Light Orange-red
      ];

      const updatedExtensions = response.data.result.map((item, index) => {
        // Use index to cycle through background colors
        const backgroundColor = backgroundColors[index % backgroundColors.length];

        return {
          ...item,
          background: backgroundColor,
          isAvailable: item.plan.includes(subscription.CardId),
          shadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)", // Consistent shadow for all
        };
      });

      setExtensions(updatedExtensions);
    } catch (error) {
      console.error("Failed to fetch extensions:", error);
    }
  };

  useEffect(() => {
    getExtensions();
  }, [storeExtention]);

  return extensions;
};

export default DefaultExtensions;
